<template>
  <div class="pc-container">
    <div v-for="(item,index) in data" :key="index">
      <component :is="item.type" :data="item"></component>
    </div>
  </div>
</template>

<script>
import {usData} from "@/data";
export default {
  name: 'UsView',
  data(){
    return {
      data:usData
    }
  }
}
</script>
<style lang="scss" scoped></style>
